var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 135,
    viewBox: "0 0 375 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_12431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 135
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H365C370.523 0 375 4.47715 375 10V135H0V10Z",
    fill: "#276E91",
    fillOpacity: 0.74
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_12431)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 24.5,
    r: 47.5,
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 108.5,
    r: 22.5,
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.5,
    cy: 18.5,
    r: 53.5,
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 71.5,
    r: 33.5,
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.5,
    cy: 151.5,
    r: 53.5,
    fill: "white",
    fillOpacity: 0.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponbg);
export default __webpack_public_path__ + "static/media/couponbg.0377593f528e2fe8b00d0a35c7b11440.svg";
export { ForwardRef as ReactComponent };